export enum ELoginStateIs {
    LoggedIn,
    LoggedOut,
    Both,
}
